import React, { useState } from 'react';
import { Button } from '@vtblife/uikit';

import classname from '@search/classname/src';

import { useClassifiedOfferDataLayerPush } from '../../../../../../domain/offer/analytics/ClassifiedOfferGtmContext';
import { Mortgage2ConsultModal } from '../consult/Mortgage2ConsultModal';
import type { Mortgage2ContactsFormSendProps } from '../mortgage2ContactsFormSend';

import './Mortgage2StarterButton.css';
const cn = classname.bind(null, 'Mortgage2StarterButton');

type Mortgage2StarterButtonProps = {
    dataTest?: string;
    gtmClickId?: string;
    isMobile?: boolean;
    enableInnerText360?: boolean;
}

export function Mortgage2StarterButton({
    dataTest,
    gtmClickId,
    isMobile,
    regionId,
    applicationId,
    locationPlacement,
    enableInnerText360,
    realtyType
}: Mortgage2StarterButtonProps & Mortgage2ContactsFormSendProps) {
    const dataLayerPush = useClassifiedOfferDataLayerPush();
    const [ isModalOpened, setsIModalOpened ] = useState(false);

    return (<>
        {isModalOpened ? <Mortgage2ConsultModal
            locationPlacement={locationPlacement}
            realtyType={realtyType}
            regionId={regionId}
            applicationId={applicationId}
            onClose={() => setsIModalOpened(false)}
            isMobile={isMobile}
        /> : null}
        <Button
            fullWidth
            variant='accent'
            dataTest={dataTest}
            onClick={() => {
                gtmClickId && dataLayerPush({ event: gtmClickId });
                setsIModalOpened(true);
            }}
        >
            <span className={cn('inner-text-360', { enableInnerText360 })}>Ипотека</span>
            <span className={cn('inner-text', { enableInnerText360 })}>Купить в ипотеку</span>
        </Button>
    </>);
}
